import { useRef } from "react";

export function useDragScroll({ threshold = 8 } = {}) {
  const containerRef = useRef(null);

  const isDown = useRef(false);
  const isDragging = useRef(false);
  const startX = useRef(0);
  const scrollLeft = useRef(0);

  const onMouseDown = (e) => {
    if (!containerRef.current) return;

    isDown.current = true;
    isDragging.current = false;

    startX.current = e.pageX - containerRef.current.offsetLeft;
    scrollLeft.current = containerRef.current.scrollLeft;
  };

  const onMouseLeave = () => {
    isDown.current = false;
  };

  const onMouseUp = () => {
    isDown.current = false;
  };

  const onMouseMove = (e) => {
    if (!isDown.current || !containerRef.current) return;

    const x = e.pageX - containerRef.current.offsetLeft;
    const walk = x - startX.current;

    if (Math.abs(walk) > threshold) {
      isDragging.current = true;
    }

    if (isDragging.current) {
      e.preventDefault();
      containerRef.current.scrollLeft = scrollLeft.current - walk;
    }
  };

  const onClickCapture = (e) => {
    if (isDragging.current) {
      e.preventDefault();
      e.stopPropagation();
    }
  };

  return {
    containerRef,
    dragHandlers: {
      onMouseDown,
      onMouseLeave,
      onMouseUp,
      onMouseMove,
      onClickCapture,
    },
    isDragging, // optional if you want to react to state outside
  };
}